// TODO: This should be implemented in a better way. it's a hack for Summer Promo
// We couldn't use get function because endpoint doesn't follow jsonapi standards and it will
// break if it throws 404 (most cases)

const handleResponse = (response) =>
  response.text().then((text) => {
    response.data = text ? JSON.parse(text) : {}
    return response
  })

export const checkEmail = async (email) => {
  const url = `/api/v1/accounts/check_email?email=${encodeURIComponent(email)}`

  return fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(handleResponse)
}
